module.exports = {
  __depends__: [
    require(80),
    require(98),
    require(155)
  ],
  __init__: [ 'modeling' ],
  modeling: [ 'type', require(115) ],
  layouter: [ 'type', require(172) ]
};
